import { Injectable } from "@angular/core";
import { GetPasswordComplexitySettingsService } from "@modules/api/get-password-complexity-settings.service.generated";
import { GetPasswordComplexitySettingsResult } from "@modules/api/get-password-complexity-settings-result.generated";
import { Observable, ReplaySubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PasswordComplexitySettingsService {
    constructor(
        private _getPasswordComplexitySettingsService: GetPasswordComplexitySettingsService
    ) {
        this._getPasswordComplexitySettingsService.getPasswordComplexitySettings()
            .subscribe(result => this._passwordComplexitySettingsSubject.next(result));
    }

    public get passwordComplexitySettingsChanged(): Observable<GetPasswordComplexitySettingsResult> {
        return this._passwordComplexitySettingsSubject;
    }

    private _passwordComplexitySettingsSubject = new ReplaySubject<GetPasswordComplexitySettingsResult>(1);
}
